import { useQuery } from '@tanstack/react-query';

import { playerStatKeys } from '@/hooks/player/playerStatsKeys';
import { getPlayerStatsController } from '@/interface-adapters/controllers/player/get-player-stats.controller';
import { useOrganizationStore } from '@/store/organization-store';

export const usePlayerStatsQuery = (teamLeagueUuid: string, seasonUuid: string, playerUuid: string) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: playerStatKeys.playerStats(store.organizationUuid, teamLeagueUuid, seasonUuid, playerUuid),
		queryFn: () => getPlayerStatsController(store.organizationUuid, teamLeagueUuid, seasonUuid, playerUuid),
		enabled: !!(store.organizationUuid && teamLeagueUuid)
	});
};
